<template>
  <app-layout title="Заявки">
    <v-card height="100%" width="100%">
      <v-card-title>
        ЗАЯВКИ
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :loading="isLoading"
          :items="list"
          rows-per-page-text=""
          :rows-per-page-items="[{text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.btag }}</td>
            <td>{{ props.item.client && props.item.client.name }}</td>
            <td>{{ props.item.device && props.item.device.name }}</td>
            <td>{{ props.item.price }} руб.</td>
            <td>{{ statusById[props.item.status] || 'No  status' }}</td>
            <td>
              <v-btn
                v-if="props.item.status === 1"
                color="success"
                @click="onMakeRequest(props.item.btag)"
              >
                Выкупить
              </v-btn>
              <v-btn v-if="props.item.status >= 3 && props.item.status != 12" color="info" :href="'/api/v1/' + props.item.btag + '.pdf'" target="_blank">Договор</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </app-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppLayout from '../components/AppLayout.vue';

export default {
  name: 'Orders',
  data: () => ({
    datePicker: {
      modal: false,
      menu: false,
      menu2: false,
    },
    filters: {
      id: null,
      status: null,
      date_start: new Date().toISOString().substr(0, 10),
      date_end: new Date().toISOString().substr(0, 10),
    },
    headers: [
      {
        text: 'Номер',
        value: 'id',
      },
      {
        text: 'Клиент',
        value: 'client',
      },
      {
        text: 'Девайс',
        value: 'device',
      },
      {
        text: 'Цена',
        value: 'price',
      },
      {
        text: 'Статус',
        value: 'status',
      },
      {
        text: '',
        value: 'btn',
      },
    ],
  }),
  components: {
    AppLayout,
  },
  methods: {
    ...mapActions('orders', [
      'loadOrders',
    ]),
    filter() {
      this.loadOrders({
        filters: this.filters,
      });
    },
  },
  computed: {
    ...mapGetters('orders', ['list', 'isLoading']),
    ...mapGetters('statuses', ['statusById']),
    pagination: {
      get() {
        return this.$store.getters['orders/pagination'];
      },
      set(data) {
        this.loadOrders(data);
      },
    },
  },
};
</script>
